<template>
  <v-card
    class="card mx-auto pa-6"
    outlined
  >
    <v-list-item three-line class="pa-0">
      <v-list-item-content class="pa-0">
        <v-row>
          <v-col>
            <h1>Still have a question or need assistance?</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card-text color="secondary" class="card__title pa-0">
              Our Client Support team is here to help
            </v-card-text>
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon class="mt-2">
                    <v-img
                      src="../../assets/contact-number-icon.svg"
                      transition="scale-transition"
                    />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <contact-no/>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon class="mt-2">
                    <v-img
                      src="../../assets/message-primary.svg"
                      transition="scale-transition"
                    />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <email/>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
                  <v-card-text color="secondary" class="card__title pa-0">
              <p class="mb-0">For questions about:</p>
            </v-card-text>
            <v-card-text class="card__description pa-0 mt-2">
            <ul class="questions">
                <li>Platform navigation</li>
                <li>Research/data queries</li>
                <li>Green Street products</li>
                <li>Green Street methodologies</li>
                <li>Training needs</li>
                <li>Anything else you need help with!</li>
            </ul>
            </v-card-text>
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import ContactNo from '../contacts/phone-number.vue'
import Email from '../contacts/email.vue'

export default {
  components: {
    ContactNo,
    Email,
  },
  props: ['tag', 'title', 'description', 'icon'],
}
</script>

<style scoped>
h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.1px;
  text-transform: capitalize;
  color: #234025;
}
.card {
  border: 0;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}
.card .card__title {
  font-weight: 800;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.1px;
}
.card .card__description {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  color: #7B7D7A;
}
.card .card__btn {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.1px;
  text-transform: capitalize;
}
.card >>> .v-list-item__icon {
  margin-bottom: 0;
}
.card >>> .v-list--two-line .v-list-item, 
.card >>> .v-list-item--two-line {
  min-height: 0;
}
.card >>> .v-list-item__title {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1px;
  color: #234025;
}
.card >>> .card__title {
  margin-bottom: 0;
}
.card ul.questions {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1px;
  color: #7B7D7A;
}
ul.questions li {
  vertical-align: middle;
}
ul.questions li::marker {
  color: var(--v-primary-base);
}
</style>